<p-dialog [(visible)]="visible" [modal]="true"
    [style]="{ width: '90vw', maxWidth: '1100px' }"
    (onHide)="handleClose()" [draggable]="false" [resizable]="false">

    <!-- HEADER -->
    <div class="flex justify-center items-center dialog-header relative">
        {{ formAction }} Client Subscription
        <button (click)="handleClose()" class="absolute right-3 top-3 p-2 outline-none">
            <i class="pi pi-times text-xl"></i>
        </button>
    </div>

    <!-- BODY -->
    <div class="dialog-content">
        <form [formGroup]="assignForm" (ngSubmit)="submitForm()">

            <div class="grid formgrid p-fluid gap-4">

                <!-- TITLE -->
                <div class="col-12">
                    <h3 class="text-xl font-semibold">Client & Subscription Details</h3>
                    <p class="text-gray-500 text-sm">Choose client and subscription configuration</p>
                </div>

                <!-- CLIENT -->
                <div class="col-12 md:col-6">
                    <label>Select Client *</label>
                    <p-dropdown
                        formControlName="client_id"
                        [options]="clients"
                        optionLabel="name"
                        optionValue="client_id"
                        [filter]="true"
                        filterBy="name,email"
                        placeholder="Select client"
                        class="w-full">
                    </p-dropdown>
                </div>

                <!-- PACKAGE -->
                <div class="col-12 md:col-6">
                    <label>Select Package *</label>
                    <p-dropdown
                        formControlName="package_id"
                        [options]="packages"
                        optionLabel="package_name"
                        optionValue="package_id"
                        [filter]="true"
                        placeholder="Select package"
                        (onChange)="onPackageSelect($event)"
                        class="w-full">
                    </p-dropdown>
                </div>

                <!-- ONBOARD EXISTING CLIENT TOGGLE -->
                <div class="col-12">
                    <div class="flex items-center gap-3 p-3 rounded-xl border-2 transition-all duration-200 cursor-pointer"
                        [ngClass]="isOnboardExistingClient ? 'border-blue-400 bg-blue-50' : 'border-gray-200 bg-gray-50'"
                        (click)="isOnboardExistingClient = !isOnboardExistingClient; onOnboardToggle()">
                        <p-checkbox
                            [(ngModel)]="isOnboardExistingClient"
                            [ngModelOptions]="{ standalone: true }"
                            [binary]="true"
                            (onChange)="onOnboardToggle()"
                            (click)="$event.stopPropagation()">
                        </p-checkbox>
                        <div class="flex flex-col">
                            <span class="font-semibold text-gray-800">Onboard Existing Client</span>
                            <span class="text-sm text-gray-500">
                                Only <strong>client_id</strong> &amp; <strong>package_id</strong> will be sent — all other fields are skipped.
                            </span>
                        </div>
                        <span *ngIf="isOnboardExistingClient"
                            class="ml-auto px-2 py-1 bg-blue-500 text-white text-xs font-bold rounded-full tracking-wide">
                            ACTIVE
                        </span>
                    </div>
                </div>

                <!-- ALL OTHER FIELDS — hidden when onboard mode is active -->
                <ng-container *ngIf="!isOnboardExistingClient">

                <!-- QUANTITY -->
                <!-- <div class="col-12 md:col-4">
                    <label>Quantity *</label>
                    <p-inputNumber formControlName="quantity" min="1" class="w-full"></p-inputNumber>
                </div> -->

                <!-- STATUS -->
                <div class="col-12 md:col-4">
                    <label>Status *</label>
                    <p-dropdown
                        formControlName="status"
                        [options]="statusOptions"
                        optionLabel="label"
                        optionValue="value"
                        class="w-full">
                    </p-dropdown>
                </div>

                <!-- PAYMENT STATUS -->
                <div class="col-12 md:col-4">
                    <label>Payment Status </label>
                    <p-dropdown
                        readonly
                        formControlName="payment_status"
                        [options]="paymentStatus"
                        optionLabel="label"
                        optionValue="value"
                        class="w-full bg-gray-200 cursor-not-allowed">
                    </p-dropdown>
                </div>

                <div class="col-12 md:col-6">
                    <label class="font-medium mb-2 block">Billing Type *</label>
                    <div class="flex gap-4">
                        <div class="flex align-items-center gap-2">
                            <p-radioButton name="billing_type" value="Recurring" formControlName="billing_type"></p-radioButton>
                            <label>Recurring</label>
                        </div>
                        <div class="flex align-items-center gap-2">
                            <p-radioButton name="billing_type" value="Fixed" formControlName="billing_type"></p-radioButton>
                            <label>Fixed</label>
                        </div>
                    </div>
                </div>

                <!-- AUTO RENEW -->
                <div class="col-12 md:col-6" *ngIf="assignForm.value.billing_type == 'Recurring'">
                    <label class="font-medium mb-2 block">Billing Automation *</label>
                    <div class="flex gap-4 mt-2">
                        <div class="flex align-items-center gap-2">
                            <p-radioButton name="billing_mode" value="Invoice" formControlName="billing_mode"></p-radioButton>
                            <label>Enable Auto Invoice</label>
                        </div>
                        <div class="flex align-items-center gap-2">
                            <p-radioButton name="billing_mode" value="Renew" formControlName="billing_mode"></p-radioButton>
                            <label>Enable Auto Renew</label>
                        </div>
                    </div>
                </div>

                <!-- RENEWAL OPTIONS -->
                <div *ngIf="assignForm.value.billing_mode" class="col-12 bg-gray-50 p-4 rounded-lg border">
                    <h4 class="text-lg font-medium mb-3">Auto {{assignForm.value.billing_mode}} Settings</h4>
                    <div class="grid grid-nogutter p-fluid gap-4">
                        <div class="col-12 md:col-6">
                            <label>Billing Cycle *</label>
                            <p-dropdown formControlName="billing_cycle" [options]="billingCycles"
                                optionLabel="label" optionValue="value"
                                (onChange)="updateBillingDates()" class="w-full">
                            </p-dropdown>
                        </div>
                        <div class="col-12 md:col-6">
                            <label>Billing Occurrences *</label>
                            <input pInputText formControlName="billing_occurrences" class="w-full bg-gray-200 cursor-not-allowed" />
                        </div>
                    </div>
                </div>

                <!-- SUBSCRIPTION PERIOD -->
                <div class="col-12 bg-gray-50 p-4 rounded-lg border">
                    <h4 class="text-lg font-semibold mb-3">Subscription Period</h4>
                    <div class="grid p-fluid formgrid gap-4">
                        <div class="col-12 md:col-6">
                            <label class="font-medium mb-1 block">Billing Start Date *</label>
                            <p-calendar formControlName="current_period_start" dateFormat="yy-mm-dd"
                                (onSelect)="updateBillingDates()" class="w-full">
                            </p-calendar>
                        </div>
                        <div class="col-12 md:col-6" *ngIf="assignForm.value.billing_type == 'Fixed'">
                            <label class="font-medium mb-1 block">Billing End Date</label>
                            <p-calendar formControlName="current_period_end" readonlyInput="true"
                                dateFormat="yy-mm-dd" class="w-full bg-gray-200 cursor-not-allowed">
                            </p-calendar>
                        </div>
                    </div>

                    <p-divider></p-divider>

                    <div class="flex items-center gap-2 mb-3">
                        <p-checkbox formControlName="is_trial" [binary]="true"></p-checkbox>
                        <label class="font-medium">Enable Trial Period</label>
                    </div>

                    <div *ngIf="assignForm.value.is_trial" class="grid p-fluid formgrid gap-4">
                        <div class="col-12 md:col-6">
                            <label class="font-medium mb-1 block">Trial Start *</label>
                            <p-calendar formControlName="trial_start" dateFormat="yy-mm-dd" class="w-full"></p-calendar>
                        </div>
                        <div class="col-12 md:col-6">
                            <label class="font-medium mb-1 block">Trial End *</label>
                            <p-calendar formControlName="trial_end" dateFormat="yy-mm-dd" class="w-full"></p-calendar>
                        </div>
                    </div>

                    <p-divider></p-divider>

                    <div class="grid p-fluid formgrid gap-4">
                        <div class="col-12 md:col-4">
                            <label class="font-medium mb-1 block">Grace Period (days)</label>
                            <p-inputNumber formControlName="grace_period_days" class="w-full"></p-inputNumber>
                        </div>
                        <div class="col-12 md:col-4">
                            <label class="font-medium mb-1 block">Reminder Before (days)</label>
                            <p-inputNumber formControlName="reminder_before_days" class="w-full"></p-inputNumber>
                        </div>
                        <div class="col-12 md:col-4 flex items-center gap-2 mt-4 md:mt-0" *ngIf="assignForm.value.billing_type == 'Fixed'">
                            <p-checkbox formControlName="cancel_at_period_end" [binary]="true"></p-checkbox>
                            <label class="font-medium">Cancel at Period End</label>
                        </div>
                    </div>
                </div>

                </ng-container>
                <!-- END: normal fields -->

            </div>

            <!-- FOOTER BUTTONS -->
            <div class="flex justify-end gap-3 mt-4">
                <p-button label="Cancel" text (onClick)="handleClose()"></p-button>
                <p-button
                    [label]="isOnboardExistingClient ? 'Onboard Client' : 'Save Subscription'"
                    [icon]="isOnboardExistingClient ? 'pi pi-user-plus' : 'pi pi-check'"
                    type="submit"
                    [loading]="isLoading"
                    [disabled]="isLoading || (!isOnboardExistingClient && assignForm.invalid)">
                </p-button>
            </div>

        </form>
    </div>

</p-dialog>
